export const PaymentProviders = {
  STRIPE: "Stripe",
};
